// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__naiAV","title":"FrontImage_title__2qDl4"};